import { render } from "./IconLaterality.vue?vue&type=template&id=0bdac9ea&lang=html"
import script from "./IconLaterality.vue?vue&type=script&lang=js"
export * from "./IconLaterality.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__